import React, { memo, useLayoutEffect, useState } from 'react';
import CardDetail from './cardDetail';
import FlatList from 'flatlist-react/lib';
import { Col, Row } from 'antd';
import { useUI } from 'store/UI/selectors';
import { useNavigate } from 'react-router-dom';
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import { handleListUserClasses } from 'store/userClasses/thunks';
import { useDispatch } from 'react-redux';
import SentryWrap from 'components/Sentry';

function ParentsStudentHome() {
  const dispatch = useDispatch();
  const { parentStudents = [] } = useUI();
  const [loading, setLoading] = useState({loading: false, student_id: null});
  const navigate = useNavigate();
  const { handleUpdateActiveStudent } = useActiveStudentofParent();

  useLayoutEffect(() => {
    if (parentStudents?.length === 1) {
      handleUpdateActiveStudent(parentStudents[0]?.student_id);
      navigate(`/parent/home`);
    }
  }, [parentStudents]);

  const handleRedirect = async (student_id) => {
    try {
      setLoading({loading: true, student_id: student_id});
      handleUpdateActiveStudent(student_id);
      await dispatch(handleListUserClasses(student_id));
      navigate(`/parent/home`);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading({loading: false, student_id: null});
    }
  };

  const renderItem = (item) => {
    return (
      <CardDetail
        loading={loading.loading && loading.student_id === item.student_id}
        handleRedirect={(student_id) => handleRedirect(student_id)}
        student={item}
      />
    );
  };

  return (
    <SentryWrap>
    <Row className="teacherHm">
      <Col xs={24} sm={24} md={24} lg={20}>
        <Row
          className="teacherHmInr"
          gutter={[40, 40]}
          style={{ paddingLeft: 16, marginBottom: 80 }}
        >
          <FlatList
            list={parentStudents}
            renderItem={renderItem}
            renderWhenEmpty={() => <div>{`No Student`}</div>}
            sortBy={['id']}
          />
        </Row>
      </Col>
      <Col xs={24} sm={24} md={24} lg={4}>      </Col>
    </Row>
    </SentryWrap>
  );
}

export default memo(ParentsStudentHome);
